import React from 'react'

export const MapMarker = () => {

  return <i className="fa fa-map-marker"/>
}